import {createFileRoute, Outlet} from "@tanstack/react-router";
import {AuthLayout} from "@/layouts/AuthLayout";
import {AuthGuard} from "@/guards/AuthGuard";

export const Route = createFileRoute("/auth")({
  component: () => (
    <AuthGuard to={"/"} guest>
      <AuthLayout>
        <Outlet/>
      </AuthLayout>
    </AuthGuard>
  ),
});
